import { isFinite, isNumber } from 'lodash/fp'

export const isFiniteNumber = (value: unknown): value is number =>
  isFinite(value) && isNumber(value)
